type EntryPointState = {
	flagOn: boolean;
	hasBaselineItems: boolean;
	shouldBlockBaseline: boolean;
	baselineLocked: boolean;
	canCreatePhase: boolean;
	/** The project already has phases (or deliverables, where it uses them), so the insert replaces them. */
	hasContent: boolean;
	canDeletePhase: boolean;
};

/**
 * The Insert Baseline Template button shows only while the Baseline builder stepper does, and only
 * when the user may do the insert: creating phases always, and deleting them too when the insert
 * would replace existing content.
 */
export const canShowInsertBaselineTemplate = (state: EntryPointState): boolean =>
	state.flagOn &&
	!state.hasBaselineItems &&
	!state.shouldBlockBaseline &&
	!state.baselineLocked &&
	state.canCreatePhase &&
	(!state.hasContent || state.canDeletePhase);
